import Vue from 'vue';

const getClient = () => Vue.api.getClient('catalog');

export const TYPE = {
  REQUEST: 'R',
  INCIDENT: 'I',
  PROBLEM: 'P',
};

const initialState = {
  catalog: null,
  categories: { [TYPE.REQUEST]: {}, [TYPE.INCIDENT]: {}, [TYPE.PROBLEM]: {} },
  elements: {},
  status: '',
  error: null,
};

export const STATUS = {
  LOADING: 'catalog.status.loading',
  SUCCESS: 'catalog.status.success',
  ERROR: 'catalog.status.error',
};

const getters = {
  loaded: (state) => (type, categoryId) => !(state.status === STATUS.LOADING)
    && typeof (state.categories[type][categoryId] || {}).model !== 'undefined',
  storedElements: (state) => (
    ticketType, categoryId,
  ) => (state.categories[ticketType][categoryId] || {}).elements != null,
  checkElement: (state) => (elementId) => typeof state.elements[elementId] !== 'undefined',
  element: (state) => (id) => state.elements[id],
};

const mutations = {
  setCatalog(state, catalog) {
    state.catalog = catalog;
  },
  setCategories(state, { categories, type }) {
    state.categories[type] = categories.reduce((acum, category) => {
      // eslint-disable-next-line no-param-reassign
      acum[category.id] = {
        model: category,
        elements: null,
      };
      return acum;
    }, {});
  },
  setCategoryElements(state, { elements, type, categoryId }) {
    if (typeof state.categories[type][categoryId] === 'undefined') {
      throw new Error(`invalid categories with category ${categoryId}}`);
    }
    state.categories[type][categoryId].elements = elements;
  },
  setElement(state, { elementId, element }) {
    state.elements = { ...state.elements, [elementId]: element };
  },
  set(state, { elements, type, categoryId }) {
    if (typeof state.categories[type][categoryId] === 'undefined') {
      throw new Error(`invalid categories with category ${categoryId}}`);
    }
    state.categories[type][categoryId].elements = elements;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setError(state, error) {
    state.error = error;
  },
  reset(state) {
    Object.keys(state)
      .forEach((key) => {
        state[key] = initialState[key];
      });
  },
};

const actions = {
  async loadCatalog({ commit }, { userId, locationId }) {
    try {
      const catalogResponse = await getClient().getCatalog(userId, locationId);
      const catalog = catalogResponse.unique();

      commit('setCatalog', catalog);

      return catalog;
    } catch (err) {
      commit('setError', err);
      commit('setStatus', STATUS.ERROR);

      throw err;
    }
  },

  async loadCatalogCategories({ commit, state }, { userId, locationId, type }) {
    try {
      commit('setStatus', STATUS.LOADING);

      let catalogId = state.catalog != null ? state.catalog.id : null;
      if (catalogId == null) {
        const catalogResponse = await getClient().getCatalog(userId, locationId);
        const catalog = catalogResponse.unique();

        commit('setCatalog', catalog);
        catalogId = catalog.id;
      }

      const response = await getClient().getCatalogCategories(catalogId, userId, type);

      commit('setCategories', {
        categories: response.list,
        type,
      });
      commit('setStatus', STATUS.SUCCESS);

      return true;
    } catch (err) {
      commit('setError', err);
      commit('setStatus', STATUS.ERROR);

      throw err;
    }
  },
  async loadCategoryElements({ commit, state }, { categoryId, type }) {
    try {
      commit('setStatus', STATUS.LOADING);
      const response = await getClient().getCategoryElements(categoryId, type);
      if (Object.keys(state.categories[type]).length > 0) {
        commit('setCategoryElements', {
          elements: response.list,
          categoryId,
          type,
        });

        commit('setStatus', STATUS.SUCCESS);
      }

      return true;
    } catch (err) {
      commit('setError', err);
      commit('setStatus', STATUS.ERROR);

      throw err;
    }
  },
  async loadElement({ commit }, { elementId, type }) {
    try {
      commit('setStatus', STATUS.LOADING);
      const response = await getClient().getElement(elementId, type);
      if (!response.list && (response.status === 403 || response.status === 404)) {
        throw response;
      }
      const element = response.unique();
      commit('setElement', {
        elementId,
        element,
      });
      commit('setStatus', STATUS.SUCCESS);
      return true;
    } catch (err) {
      commit('setError', err);
      commit('setStatus', STATUS.ERROR);
      throw err;
    }
  },
  async loadCatalogIncidents({ commit, state }, { userId, locationId, type }) {
    try {
      commit('setStatus', STATUS.LOADING);
      // const catalogId = state.catalog != null ? state.catalog.id : null;
      let catalog = state.catalog || null;
      if (catalog == null) {
        const catalogResponse = await getClient().getCatalog(userId, locationId);
        catalog = catalogResponse.unique();
      }
      const categoryResponse = await getClient().getCatalogCategories(catalog.id, userId, type);
      const category = categoryResponse.unique();

      const elementResponse = await getClient().getCategoryElements(category.id, type);
      const elements = elementResponse.list;
      commit('setCatalog', catalog);

      commit('setCategories', {
        categories: [category],
        type,
      });
      commit('setCategoryElements', {
        elements,
        categoryId: category.id,
        type,
      });
      commit('setStatus', STATUS.SUCCESS);
      return true;
    } catch (err) {
      commit('setError', err);
      commit('setStatus', STATUS.ERROR);
      throw err;
    }
  },
  reset({ commit }) {
    console.log('catalogs reset action received');
    commit('reset');
  },

};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
